export default __webpack_public_path__ + "static/Photo of Leon Michalak S-23ba1ae5c8a0896697c952fa779fc3f1.jpg";